(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dusha-refill-subscription"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dusha-refill-subscription')) {
    customElements.define(
      'dusha-refill-subscription',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.closest('form');

          if (!this.form || this.controller) return;

          this.controller = new AbortController();

          const options = { signal: this.controller.signal };

          this.data = JSON.parse(
            this.querySelector('[data-subscription-data]').textContent
          );

          this.planInput = this.querySelector('input[name="selling_plan"]');

          this.mode = 'once';

          this.addEventListener(
            'change',
            (event) => {
              if (event.target.name.startsWith('dusha_purchase_')) {
                this.mode = event.target.value;
              }

              if (event.target.name.startsWith('dusha_frequency_')) {
                this.planId = event.target.value;
              }

              this.updateSelection();
            },
            options
          );

          this.form.addEventListener(
            'change',
            (event) => {
              if (event.target.name === 'id') {
                this.setVariant(event.target.value);
              }
            },
            options
          );

          document.addEventListener(
            'product:variant-change',
            (event) => {
              if (String(event.detail.sectionId) === this.dataset.section) {
                this.setVariant(event.detail.variant?.id);
              }
            },
            options
          );

          this.setVariant(
            this.form.querySelector('input[name="id"]')?.value ||
              this.dataset.variant
          );

          this.hidden = false;
        }

        disconnectedCallback() {
          this.controller?.abort();
          this.controller = null;
          this.form?.classList.remove('dusha-subscription-active');
        }

        setVariant(id) {
          const variant = this.data.variants.find(
            (item) => String(item.id) === String(id)
          );

          if (this.variant === variant && this.initialized) return;

          this.initialized = true;
          this.variant = variant;

          const eligible = Boolean(variant?.plans.length);

          if (!eligible) {
            this.mode = 'once';
          }

          this.querySelector('[data-refill-hint]').hidden = eligible;
          this.querySelector('[data-purchase-options]').hidden = !eligible;

          this.querySelectorAll('.dusha-purchase-options input').forEach((input) => {
            input.disabled = !eligible;
            input.checked = input.value === this.mode;
          });

          const frequencyOptions = this.querySelector(
            '[data-frequency-options]'
          );

          frequencyOptions.replaceChildren();

          if (eligible) {
            const currentPlan =
              variant.plans.find((plan) => plan.id === this.planId) ||
              variant.plans.find((plan) => plan.weeks === 4) ||
              variant.plans[0];

            this.planId = currentPlan.id;

            variant.plans.forEach((plan) => {
              const label = document.createElement('label');
              label.className = 'dusha-frequency-choice';

              const input = document.createElement('input');
              input.type = 'radio';
              input.name = `dusha_frequency_${this.dataset.section}`;
              input.value = plan.id;
              input.checked = plan.id === this.planId;

              const text = document.createElement('span');
              text.textContent = plan.label;

              label.append(input, text);
              frequencyOptions.append(label);
            });

            this.querySelector('[data-one-time-price]').textContent =
              variant.formattedPrice;

            this.querySelector('[data-original-price]').textContent =
              variant.formattedPrice;
          }

          const jarLabel = this.form.querySelector(
            '[name="properties[Include matching jar label]"]'
          );

          if (jarLabel) {
            const jarLabelEligible = Boolean(
              eligible && variant?.jarLabelEligible
            );

            jarLabel.disabled = !jarLabelEligible;

            if (!jarLabelEligible) {
              jarLabel.checked = false;
            }

            jarLabel.closest('.refill-option').style.display =
              jarLabelEligible ? 'block' : 'none';
          }

          this.updateSelection();
        }

        updateSelection() {
          const plan = this.variant?.plans.find(
            (item) => item.id === this.planId
          );

          const recurring = Boolean(
            plan && this.mode === 'subscription'
          );

          this.planInput.disabled = !recurring;
          this.planInput.value = recurring ? plan.id : '';

          this.querySelector('[data-subscription-details]').hidden =
            !recurring;

          this.querySelectorAll('.dusha-frequency input').forEach((input) => {
            input.disabled = !recurring;
          });

          this.form.classList.toggle(
            'dusha-subscription-active',
            recurring
          );

          if (plan) {
            this.querySelector('[data-recurring-price]').textContent =
              plan.formattedPrice;

            this.querySelector('[data-selected-price]').textContent =
              plan.formattedPrice;

            const saving =
              this.variant.price > 0
                ? Math.round(
                    (1 - plan.price / this.variant.price) * 100
                  )
                : 0;

            const badge = this.querySelector('[data-saving]');

            badge.textContent = this.data.save.replace(
              '__PERCENT__',
              String(saving)
            );

            badge.hidden = saving <= 0;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
